import React from 'react';

import FiltersContentLoader from '../FiltersContentLoader';

import FilterFaxTypeList from './FilterFaxTypeList';

import { TFaxDocumentCategory } from './useFaxDocumentCategoryPagination';

interface FaxTypeQueryObject {
  allItems?: TFaxDocumentCategory[];
  isLoading?: boolean;
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
}

interface FilterFaxTypeDataProps {
  type: string;
  queryObject: FaxTypeQueryObject;
}

const FilterFaxTypeData: React.FC<FilterFaxTypeDataProps> = ({ queryObject, type }) => {
  const { allItems, isLoading, hasNextPage, fetchNextPage } = queryObject;

  if (!allItems) return null;

  return (
    <FilterFaxTypeList
      type={type}
      data={allItems}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
    />
  );
};

export default (props: any) => (
  <React.Suspense fallback={<FiltersContentLoader />}>
    <FilterFaxTypeData {...props} />
  </React.Suspense>
);
